
import { instantiate } from './looperkt-demos-starparallax-wasm-js.uninstantiated.mjs';
export default (await instantiate()).exports;
